import { useState, useEffect, useRef } from 'react';
import { buscarConteudoHome } from '../utils/homeContent';

const LS_KEY = 'home_last_seen_fp';

function fingerprint(slides, shorts, agenda) {
  const all = [...slides, ...shorts, ...agenda];
  if (all.length === 0) return null;
  return all.length + ':' + all.map(i => i.id).join(',');
}

export function useHomeContent() {
  const [homeSlides, setHomeSlides] = useState([]);
  const [homeShorts, setHomeShorts] = useState([]);
  const [homeAgenda, setHomeAgenda] = useState([]);
  const [showHomeBadge, setShowHomeBadge] = useState(false);
  const fpRef = useRef(null);

  useEffect(() => {
    buscarConteudoHome().then(({ carrosselSlides, shortsDoClube, agendaDoMes }) => {
      setHomeSlides(carrosselSlides);
      setHomeShorts(shortsDoClube);
      setHomeAgenda(agendaDoMes);

      const fp = fingerprint(carrosselSlides, shortsDoClube, agendaDoMes);
      fpRef.current = fp;
      if (fp && fp !== localStorage.getItem(LS_KEY)) {
        setShowHomeBadge(true);
      }
    });
  }, []);

  function markHomeSeen() {
    if (fpRef.current) localStorage.setItem(LS_KEY, fpRef.current);
    setShowHomeBadge(false);
  }

  return { homeSlides, homeShorts, homeAgenda, showHomeBadge, markHomeSeen };
}
